module.exports = __webpack_public_path__ + "img/album18_09.74f80c5c.jpg";